export default "__VITE_ASSET__B81oQhH7__"